import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sites-list',
  templateUrl: './sites-list.component.html',
  styleUrls: ['./sites-list.component.scss']
})
export class SitesListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
